export default "<p>success-page works!</p>\n<div id=\"ipr\">{{iprData}}</div>"